import Axios, { AxiosInstance } from 'axios';

import {
  NetworkConfig,
  NetworkInstance,
  NetworkRequestConfig,
  NetworkResponse
} from './network-factory';

class AxiosAdapter implements NetworkInstance {
  private service: AxiosInstance;

  constructor(config: NetworkConfig) {
    this.service = Axios.create({
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      ...config
    });
  }

  public get = (
    url: string,
    { params = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> =>
    this.service.get(url, {
      ...config,
      params
    });

  public post = (
    url: string,
    { data = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> => this.service.post(url, data, config);

  public put = (
    url: string,
    { data = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> => this.service.put(url, data, config);

  public delete = (
    url: string,
    { data = {}, config = {} }: NetworkRequestConfig = {}
  ): Promise<NetworkResponse> =>
    this.service.delete(url, {
      ...config,
      data
    });
}

export default AxiosAdapter;
